import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.ef-app-pc-e .img-wrapper', { opacity: 1 }, { opacity: 0.5 }, 1],
                ['.ef-app-pc-e .text-wrapper', { opacity: 0 }, { opacity: 1 }, 2],
            ],
            asyncTimeLine: [0, 0],
            triggerElement: '.ef-app-pc-e',
            triggerHook: 1,
            offset: '120%',
            duration: '100%',
        });
    }, []);

    return (
        <div className={`ef-app-pc-e ${css.efAppPCE}`}>
            <div className="img-wrapper">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/5.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/5.jpg')}
                    alt={t('sec4_title')}
                    aria-label={t('sec4_title')}
                />
            </div>
            <div className="sticky-wrapper">
                <div className="text-wrapper">
                    <p className="sub-title">{t('sec5_subtitle')}</p>
                    <p className="title">{t('sec5_title')}</p>
                </div>
            </div>
        </div>
    );
}
